(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_group-announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('announcement-marquee')) {
    customElements.define('announcement-marquee', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.announcement-marquee__pause');
        this.onPause = () => {
          const paused = this.toggleAttribute('data-paused');
          this.button.setAttribute('aria-pressed', String(paused));
        };
        this.button.addEventListener('click', this.onPause);
        this.cleanClones = () => {
          this.querySelectorAll('.marquee__content[aria-hidden="true"], .marquee__repeated-items[aria-hidden="true"]').forEach((clone) => {
            clone.inert = true;
            clone.querySelectorAll('[id], [data-shopify-editor-block]').forEach((element) => {
              element.removeAttribute('id');
              element.removeAttribute('data-shopify-editor-block');
            });
          });
        };
        this.observer = new MutationObserver(this.cleanClones);
        this.observer.observe(this.querySelector('marquee-component'), { childList: true, subtree: true });
        this.cleanClones();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.button?.removeEventListener('click', this.onPause);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-customer-viewing"] && !Shopify.designMode) return;
  try {
    class CustomerViewingComponent extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-customer-viewing-number]');
      if (!numberElem) return;

      const numbersViewerStr = this.dataset.customerView;
      if (!numbersViewerStr) return;

      const numbersViewerList = numbersViewerStr
        .split(',')
        .map(item => parseInt(item.trim(), 10))
        .filter(num => !isNaN(num) && num > 0);

      if (!numbersViewerList.length) return;

      let timeViewer = parseInt(this.dataset.customerViewTime, 10);
      if (isNaN(timeViewer) || timeViewer < 1) timeViewer = 5;
      timeViewer = timeViewer * 1000;

      const updateNumber = () => {
        const randomIdx = Math.floor(Math.random() * numbersViewerList.length);
        const value = numbersViewerList[randomIdx];
        numberElem.textContent = value;
      };

      updateNumber();

      this.timer = setInterval(updateNumber, timeViewer);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('customer-viewing-component')) {
      customElements.define('customer-viewing-component', CustomerViewingComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-positive-vibes"] && !Shopify.designMode) return;
  try {
    class PositiveVibesComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const parent = this.querySelector('.text-vibes');
      const children = this.querySelectorAll('.text-vibes--child');
      let currentIndex = 0;

      if (children.length > 1) {
        const newDiv = document.createElement("div");
        newDiv.classList.add("text-vibes--child");
        newDiv.innerHTML = children[0].innerHTML;
        parent.appendChild(newDiv);

        const childrenTexts = parent.querySelectorAll('.text-vibes--child');
        setInterval(() => {
          if (parent) {
            parent.classList.add('js-active');
          }
          const height = childrenTexts[currentIndex].offsetHeight;
          childrenTexts.forEach((child, index) => {
            parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
            if (currentIndex == 0) {
              parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
            }
          });
          currentIndex = (currentIndex + 1) % childrenTexts.length;
          this.heightPositive();
        }, 3000);
      }
    }

    heightPositive() {
      const parent = this.querySelector('.text-vibes');
      const childrenTexts = this.querySelectorAll('.text-vibes--child');

      let maxHeight = 0;
      childrenTexts.forEach(child => {
        maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
      });

      this.style.minHeight = maxHeight + 'px';

      childrenTexts.forEach(child => {
        child.style.minHeight = `${maxHeight}px`;
      });
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('positive-vibes-component')) {
      customElements.define('positive-vibes-component', PositiveVibesComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_product-sold-in-last"] && !Shopify.designMode) return;
  try {
    class SoldInLastComponent extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const numberElem = this.querySelector('[data-sold-out-number]');
      const hoursElem = this.querySelector('[data-sold-out-hours]');

      let numbersListStr = this.dataset.items || this.getAttribute('data-items') || "3,5,6,7,8,10,12,15";
      let hoursListStr = this.dataset.hours || this.getAttribute('data-hours') || "10,15,16,17,18,20,25,35";

      const numbersList = numbersListStr.split(',').map(item => item.trim()).filter(item => !!item);
      const hoursList = hoursListStr.split(',').map(item => item.trim()).filter(item => !!item);

      const numberIdx = Math.floor(Math.random() * numbersList.length);
      const hourIdx = Math.floor(Math.random() * hoursList.length);

      if (numberElem && numbersList.length > 0) {
        numberElem.textContent = numbersList[numberIdx];
      }
      if (hoursElem && hoursList.length > 0) {
        hoursElem.textContent = hoursList[hourIdx];
      }
      this.classList.remove('loading');
    }
  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('sold-in-last-component')) {
      customElements.define('sold-in-last-component', SoldInLastComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["creator-journey-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('creator-journey-tabs')) {
    customElements.define(
      'creator-journey-tabs',
      class CreatorJourneyTabs extends HTMLElement {
        connectedCallback() {
          this.panels = [...this.querySelectorAll('[data-journey-panel]')];
          this.tablist = this.querySelector('.creator-journey-tabs__list');
          this.buildTabs();
          this.tabs = [...this.querySelectorAll('[data-journey-tab]')];

          const defaultPanel = this.panels.find((panel) => panel.classList.contains('is-active'));
          const defaultTab = defaultPanel
            ? this.tabs.find((tab) => tab.dataset.journeyTab === defaultPanel.dataset.journeyPanel)
            : this.tabs[0];

          if (defaultTab) this.selectTab(defaultTab);

          this.tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => this.selectTab(tab));
            tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
          });

          this.handleBlockSelect = (event) => {
            const selectedPanel = this.panels.find(
              (panel) =>
                panel.dataset.journeyPanel === event.detail.blockId ||
                panel === event.target ||
                panel.contains(event.target)
            );

            if (!selectedPanel) return;

            const selectedTab = this.tabs.find(
              (tab) => tab.dataset.journeyTab === selectedPanel.dataset.journeyPanel
            );

            if (selectedTab) this.selectTab(selectedTab);
          };

          document.addEventListener('shopify:block:select', this.handleBlockSelect);
        }

        disconnectedCallback() {
          document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        }

        buildTabs() {
          this.tablist.replaceChildren();
          this.tablist.style.setProperty('--journey-tab-count', Math.max(this.panels.length, 1));

          this.panels.forEach((panel) => {
            const tab = document.createElement('button');
            const label = document.createElement('span');

            tab.className = 'creator-journey-tabs__tab';
            tab.id = `JourneyTab-${panel.dataset.journeyPanel}`;
            tab.type = 'button';
            tab.role = 'tab';
            tab.setAttribute('aria-controls', panel.id);
            tab.setAttribute('aria-label', panel.dataset.tabLabel);
            tab.setAttribute('aria-selected', 'false');
            tab.tabIndex = -1;
            tab.dataset.journeyTab = panel.dataset.journeyPanel;

            label.className = 'creator-journey-tabs__tab-label';
            const tabLabel = panel.dataset.tabLabel.trim();
            const labelWords = tabLabel.split(/\s+/);
            const splitBeforeLastWord = labelWords.length > 2 && labelWords.at(-1).toLowerCase() === 'creator';
            const labelLines = labelWords.length === 1
              ? labelWords
              : splitBeforeLastWord
                ? [labelWords.slice(0, -1).join(' '), labelWords.at(-1)]
                : [labelWords.at(0), labelWords.slice(1).join(' ')];

            labelLines.filter(Boolean).forEach((text) => {
              const line = document.createElement('span');
              line.className = 'creator-journey-tabs__tab-label-line';
              line.textContent = text;
              label.append(line);
            });
            tab.append(label);
            this.tablist.append(tab);
          });
        }

        selectTab(selectedTab) {
          const selectedId = selectedTab.dataset.journeyTab;

          this.tabs.forEach((tab) => {
            const isActive = tab === selectedTab;
            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
            tab.tabIndex = isActive ? 0 : -1;
          });

          this.panels.forEach((panel) => {
            const isActive = panel.dataset.journeyPanel === selectedId;
            panel.classList.toggle('is-active', isActive);
            panel.hidden = !isActive;
          });
        }

        onKeydown(event, index) {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();

          let nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;

          this.tabs[nextIndex].focus();
          this.selectTab(this.tabs[nextIndex]);
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    class EmailSignup extends HTMLElement {
    constructor() {
      super();
      this._handleOutsideClick = this._handleOutsideClick.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('[id^="EmailSignup-"]');
      this.checkbox = this.form?.querySelector('[id^="agree_condition-"]');
      this.submitButton = this.form?.querySelector("button[id^='EmailSignup-submit-']");
      this.subscriptionForm = this.querySelector('.subscription-form');
      this.emailForm = this.querySelector('.email-signup__form');
      this.promoBtn = this.querySelector('.promo-btn');
      this.openNewsletterPopupButton = this.querySelector('.open-newsletter-popup-button');
      // this.backBtn = this.emailForm.querySelector('.back-btn');

      this.initAgreeCondition();
      this.initPromoToggle();
      this.openNewsletterPopup();

      if (window.location.search.includes('contact_posted=true')) {
        this.showEmailForm(true);
      }
    }

    initAgreeCondition() {
      if (!this.checkbox || !this.submitButton) return;

      this.submitButton.disabled = true;

      this.checkbox.addEventListener('change', () => {
        this.submitButton.disabled = !this.checkbox.checked;
      });

      this.form.addEventListener('submit', (e) => {
        if (!this.checkbox.checked) {
          e.preventDefault();
          alert('Please agree to the terms and conditions before submitting.');
        }
      });
    }

    initPromoToggle() {
      if (!this.subscriptionForm || !this.emailForm || !this.promoBtn) return;

      this.emailForm.style.display = 'none';

      this.promoBtn.addEventListener('click', () => this.showEmailForm());
      // this.backBtn?.addEventListener('click', () => this.showSubscriptionForm());
    }

    openNewsletterPopup() {
      if (!this.openNewsletterPopupButton) return;
      this.openNewsletterPopupButton.addEventListener('click', (e) => {
        e.preventDefault();
        const popup = document.querySelector('.promotionPopup');
        if (popup) popup.setAttribute('open', '');
        const content = document.querySelector('.promotionPopup .popup__inner');
        Motion.timeline([
          [content, { opacity: [0, 1], transform: ['translate(-50%, -40%)', 'translate(-50%, -50%)'] }, { duration: 0.3, at: '-0.15' }]
        ]).finished;
      });
    }

    async showEmailForm(skipHideAnim = false) {
      if (!skipHideAnim) await this._animateHide(this.subscriptionForm);
      this.subscriptionForm.style.display = 'none';
      this.emailForm.style.display = '';
      await this._animateShow(this.emailForm);

      document.addEventListener('click', this._handleOutsideClick);
    }

    async showSubscriptionForm() {
      await this._animateHide(this.emailForm);
      this.emailForm.style.display = 'none';
      this.subscriptionForm.style.display = '';
      await this._animateShow(this.subscriptionForm);

      document.removeEventListener('click', this._handleOutsideClick);
    }

    _handleOutsideClick(e) {
      if (!this.contains(e.target)) {
        this.showSubscriptionForm();
      }
    }

    async _animateShow(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [
          element,
          { height: ['0px', `${element.scrollHeight}px`] },
          { duration: 0.15, easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
        [
          element,
          { opacity: [0, 1], transform: ['translateX(-1rem)', 'translateX(0)'] },
          { duration: 0.15, at: '-0.1' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }

    async _animateHide(element) {
      element.style.overflow = 'hidden';
      await Motion.timeline([
        [element, { opacity: 0, transform: ['translateX(0)', 'translateX(1rem)'] }, { duration: 0.15 }],
        [
          element,
          { height: [`${element.clientHeight}px`, '0px'] },
          { duration: 0.15, at: '<', easing: 'cubic-bezier(0.7, 0, 0.3, 1)' },
        ],
      ]).finished;
      element.style.height = 'auto';
      element.style.overflow = 'visible';
    }
  }
  if (!customElements.get('email-signup')) customElements.define('email-signup', EmailSignup);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["store-locator"] && !Shopify.designMode) return;
  try {
    (function() {
    var root = document.querySelector('.storeLocator');
    if (!root) return;

    var items = root.querySelectorAll('.storeLocator__item');
    var mapEl = root.querySelector('#map');
    if (!mapEl || !items.length) return;

    function setActive(item) {
      items.forEach(function(i) { i.classList.remove('active'); });
      item.classList.add('active');
    }

    function renderMapFrom(item) {
      var html = item.getAttribute('data-map') || '';
      mapEl.classList.add('is-loading');
      mapEl.innerHTML = html;

      setTimeout(function() {
        mapEl.classList.remove('is-loading');
      }, 500);
    }

    items.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault();
        setActive(item);
        renderMapFrom(item);
      });
    });

    // Initialize with first item
    var first = items[0];
    if (first) {
      setActive(first);
      renderMapFrom(first);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-metafield-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-metafield-image')) {
    customElements.define(
      'product-metafield-image',
      class ProductMetafieldImage extends HTMLElement {
        connectedCallback() {
          this.sectionId = String(this.dataset.sectionId || '');

          if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

          this.productChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
            const target = data?.target;
            const productInfo = target?.closest('product-info');
            const eventSectionId = String(productInfo?.dataset.section || '');
            if (eventSectionId && this.sectionId && eventSectionId !== this.sectionId) return;
            if (!target?.dataset?.productUrl) return;

            this.updateImage(target.dataset.productMetafieldImage || '');
          });
        }

        disconnectedCallback() {
          this.productChangeUnsubscriber?.();
        }

        updateImage(imageUrl) {
          if (!imageUrl) {
            this.hidden = true;
            return;
          }

          let image = this.querySelector('img');
          if (!image) {
            image = document.createElement('img');
            image.className = 'variant-metafield-image__media';
            image.loading = 'lazy';
            image.alt = '';
            this.appendChild(image);
          }

          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = imageUrl;
          this.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
